import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './Container.module.scss';

type ContainerProps = {
  title?: string;
  children?: ReactNode;
  className?: string;
};

const Container: FC<ContainerProps> = ({ title, children, className }) => {
  return (
    <div className={classNames(styles.container, className && className)}>
      {title && <h2 className={styles.title}>{title}</h2>}
      {children}
    </div>
  );
};

export default Container;
